// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoPreview_video__2mTV0"};